"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstMapValue = void 0;
const first_map_entry_1 = require("./first-map-entry");
exports.firstMapValue = (map) => first_map_entry_1.firstMapEntry(map)[1];
//# sourceMappingURL=first-map-value.js.map